module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_9.35090acc.jpg";